<template>
  <el-tag :type="tagType" size="small" effect="light">
    {{ displayLabel }}
  </el-tag>
</template>

<script>
const STATUS_MAP = {
  SUCCESS: { type: 'success', label: 'Success' },
  COMPLETED: { type: 'success', label: 'Completed' },
  DELIVERED: { type: 'success', label: 'Delivered' },
  PENDING: { type: 'warning', label: 'Pending' },
  DRAFT: { type: 'info', label: 'Draft' },
  SENT: { type: '', label: 'Sent' },
  SHIPPED: { type: '', label: 'Shipped' },
  FAILED: { type: 'danger', label: 'Failed' },
  ERROR: { type: 'danger', label: 'Error' },
  EXPIRED: { type: 'danger', label: 'Expired' },
  DECLINED: { type: 'danger', label: 'Declined' },
  CANCELLED: { type: 'info', label: 'Cancelled' },
}

export default {
  name: 'EcStatusBadge',
  props: {
    status: { type: String, required: true },
  },
  computed: {
    config() {
      return STATUS_MAP[this.status] || { type: 'info', label: this.status }
    },
    tagType() {
      return this.config.type
    },
    displayLabel() {
      return this.config.label
    },
  },
}
</script>
